import { type ApiClient } from "@anna-money/anna-web-lib/api";
import { AttachmentData, AttachmentResponse } from "./attachmentTypes";

export class AttachmentClient {
  private readonly _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  attachFile = async (data: AttachmentData): Promise<AttachmentResponse> => {
    const response = await this._apiClient.post(`api/formations/attachments`, data);

    return response.getData(AttachmentResponse);
  };
}
